import UserSelectedLogo from 'components/UserSelectedLogo';
import { FaUser, FaQuestion, FaPalette, FaBug } from 'react-icons/fa';
import { UserButton, useUser } from '@clerk/clerk-react'
import { useNavigate, useLocation } from 'react-router-dom';
import Button, { ButtonVariant } from 'components/Button';
import { PageRoute } from 'constants/paths';

function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useUser();

  return (
    <div className="flex flex-col items-center h-screen text-white p-4">
      <div className="flex flex-col space-y-2 items-center">
        <UserSelectedLogo />
      </div>
      <div className="flex-1"></div>
      <div className="flex flex-col space-y-2">
        {user.isSignedIn ? (
            <UserButton />
        ) : (
            <Button
              variant={ButtonVariant.FlatNoFill}
              icon={<FaUser />}
              onClick={() => navigate(PageRoute.SIGN_UP, {replace: true})}
              selected={location.pathname === PageRoute.SIGN_UP}
              size="md"
            />
        )}
        <Button
          variant={ButtonVariant.FlatNoFill}
          icon={<FaPalette />}
          onClick={() => navigate(PageRoute.DESIGN, {replace: true})}
          selected={location.pathname === PageRoute.DESIGN}
          size="md"
        />
        <Button
          variant={ButtonVariant.FlatNoFill}
          icon={<FaQuestion />}
          onClick={() => navigate(PageRoute.ABOUT, {replace: true})}
          selected={location.pathname === PageRoute.ABOUT}
          size="md"
        />
        <Button
          variant={ButtonVariant.FlatNoFill}
          icon={<FaBug />}
          onClick={() => navigate(`/about`, {replace: true})}
          size="md"
        />
      </div>
    </div>
  );
}

export default SideBar;
